const STORAGE_KEY = 'bilenia_native_auth';

export type NativeAuthTokens = {
  accessToken: string;
  refreshToken: string;
};

export function isNativeCapacitorApp(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
}

export function saveNativeTokens(tokens: NativeAuthTokens): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
  } catch {
    /* storage full / private mode */
  }
}

export function clearNativeTokens(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function getNativeTokens(): NativeAuthTokens | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as NativeAuthTokens;
    if (parsed?.accessToken && parsed?.refreshToken) return parsed;
    return null;
  } catch {
    return null;
  }
}

/** Hash route path for Capacitor (pathname is always /). */
export function getNativeHashPath(): string {
  if (typeof window === 'undefined') return '/';
  const raw = window.location.hash.replace(/^#/, '');
  return raw.split('?')[0] || '/';
}

/** Used for cold-start routing before React hydrates. */
export function hasStoredNativeTokens(): boolean {
  return getNativeTokens() !== null;
}

// NOTE: Do not auto-clear native tokens in web contexts.
// In some native WebView boots, Capacitor may not be available immediately; clearing here
// would incorrectly log users out on cold start.
